import styled from 'styled-components';

import paypalLogo from 'assets/paypal.svg';
import { Horizontal } from 'atoms/layout/flex';
import { Text16 } from 'atoms/typography';

const PayPalLogoContainer = styled.div`
  display: flex;
  height: 30px;
  background-color: var(--c-neutral-900);
  padding: var(--half-unit) var(--half-unit);
  border-radius: var(--half-unit);
`;

export const Paypal = () => {
  return (
    <Horizontal>
      <PayPalLogoContainer>
        <img src={paypalLogo} alt="PayPal" width="38px" />
      </PayPalLogoContainer>
      <Text16 color="var(--c-neutral-1000)">PayPal</Text16>
    </Horizontal>
  );
};

export default Paypal;
